<div class="exception-body error">
    <div class="exception-content">
        <div class="exception-title">{{'AccessDenied' | translate}}</div>
        <div class="exception-detail">{{'DontHavePermission' | translate}}</div>
    </div>
</div>
